import React from "react";
import {Container} from "reactstrap";
import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
import routes from "../../routes";
import DefaultAside from "./DefaultAside";
import DefaultFooter from "./DefaultFooter";
import DefaultHeader from "./DefaultHeader";
import {getCmpV2IdsFromServiceSet} from "../../utils/cmpV2Utils";
import _ from "lodash";
import {PERMISSIONS} from "../../utils/constants";

const DefaultLayout = ({children, ...rest}) => {
  let navBarVisibility = false
  let navItems = navigation
  const {userGroupsUserServiceInfo: userGroups, userAllPermissions:permissions} = children.props.value
  const userAllPermissions =  permissions?.reduce((r, obj) => r.concat(obj.roleCode), []);
  if (userGroups?.length > 1 || userAllPermissions?.includes(PERMISSIONS.MANAGE_GROUPS) ||
    userAllPermissions?.includes(PERMISSIONS.MANAGE_USERS)) {
    navBarVisibility = true
  }

  const cmpV2Tenants = getCmpV2IdsFromServiceSet(userGroups)
  if(_.isEmpty(cmpV2Tenants)){
    navItems.items = navItems?.items.filter(item => item?.name !== "Groups")
  }

  return (
    <div className="app">
      <AppHeader fixed>
        <DefaultHeader/>
      </AppHeader>
      <div className="app-body">
        {navBarVisibility &&
          <AppSidebar fixed display="lg">
            <AppSidebarHeader/>
            <AppSidebarForm/>
            <AppSidebarNav navConfig={navItems} {...rest} />
            <AppSidebarFooter/>
            <AppSidebarMinimizer/>
          </AppSidebar>
        }
        <main className="main">
          <AppBreadcrumb appRoutes={routes}/>
          <Container fluid>
            {children}
          </Container>
        </main>
        <AppAside fixed hidden>
          <DefaultAside />
        </AppAside>
      </div>
      <AppFooter>
        <DefaultFooter />
      </AppFooter>
    </div>
  );
}

export default DefaultLayout;
